import axios from "axios";
import Data from "../dto/data";

const ressourceUrl = "/api/me";

export const findAllData = async (): Promise<Data> => {
  return axios.get(`${ressourceUrl}/data`).then(response => response.data);
};